import { IMAGE_TYPES } from '../../../../constants';

const questionsModels = [
  {
    label: 'What was your sex assigned at birth?',
    field: 'wlus_genderIdentify',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_genderIdentify_male',
          value: 'Male'
        },
        {
          key: 'wlus_genderIdentify_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    field: 'wlus_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'wlus_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    answer: {},
    reject: true,
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'wlus_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_PregnantOrBreastfeedingOrPlanningTo_yes',
          value: 'Yes'
        },
        {
          key: 'wlus_PregnantOrBreastfeedingOrPlanningTo_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'wlus_pregnantOrBreastfeedingOrPlanningTo2',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value:
            'No and I acknowledge that these medications are not safe to use during pregnancy or while breastfeeding, as they may pose risks to a developing baby.'
        }
      ]
    }
  },
  {
    field: 'wlus_consentPregnancy',
    label: 'Consent (pregnancy):',
    type: 'select',
    educationalSlide:
      'Read the following for more information about this product and its potential side effects:\n It is not safe to take these medications while pregnant or breastfeeding. The FDA advises that these medications may pose a risk to a developing fetus. Oral contraceptives alone may not be effective, as the medication can reduce their effectiveness. The FDA specifically recommends continuing oral contraception alongside a barrier method (like condoms) for the first month after starting a weight loss medication and for the first month after any dose increase. Alternatively, you can switch to a non-oral contraceptive method (such as an IUD or implant) before beginning the medication. After stopping the medication, you should continue using a backup method, such as condoms, for two months to ensure the medication has fully cleared your system before trying to conceive. Additionally, its safety during breastfeeding is unknown, so if you are nursing, consult your doctor to explore safer weight loss options.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'wlus_consentPregnancy_non_consent'
        },
        {
          value:
            'I acknowledge that I have read and understood the above information',
          class: 'option-consent',
          key: 'wlus_consentPregnancy_consent'
        }
      ]
    }
  },
  {
    label:
      'Are you currently taking a GIP/GLP-1 agonist medication such as Ozempic, Wegovy, Zepbound, Mounjaro, Semaglutide, or Tirzepatide?',
    field: 'wlus_takingGlp1AgonistMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_takingGlp1AgonistMedication_yes',
          value: 'Yes'
        },
        {
          key: 'wlus_takingGlp1AgonistMedication_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: 'What was the highest weight that you have reached?',
    field: 'wlus_highestWeight',
    type: 'info',
    answer: {
      type: 'number',
      name: 'wlus_highestWeight'
    }
  },

  {
    label: 'What is your height in feet and inches?',
    field: 'wlus_height',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'height'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'wlus_weight',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'weight'
    }
  },
  {
    label: 'Your BMI is:',
    type: 'info',
    answer: {
      type: 'calculated',
      formula: data => {
        return JSON.stringify(data, null, 2);
      }
      // TODO: Figure this out
    },

    field: 'wlus_BMI'
  },

  {
    // TODO if BMI is under 27 for a treatment naive patient → disqualified; if BMI is under 23 for a patient currently on treatment → disqualified
    label: 'What is your:',
    field: 'wlus_weightAndHeight2025',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'Your BMI is',
      heightLabel: 'What is your height in feet and inches?',
      weightLabel: 'What is your weight in pounds?'
    }
  },
  {
    // TODO if BMI is under 27 for a treatment naive patient → disqualified; if BMI is under 23 for a patient currently on treatment → disqualified
    label: 'What is your:',
    field: 'wlus_weightAndHeight',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'BMI',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  },
  {
    field: 'wlus_consentBmi',
    label: 'Consent (BMI):',
    type: 'select',
    educationalSlide:
      'The traditional use of weight loss medications is for individuals with a BMI of 30 and above or to those who are overweight who have associated health conditions. Using it for someone with a BMI range (27-29) without an accompanying health condition is termed "off-label." Using a medication "off-label" refers to the practice of prescribing a drug for a purpose, age group, dosage, or form of administration that is not included in the approved labeling by regulatory agencies like the U.S. Food and Drug Administration (FDA). While a medication undergoes rigorous testing for specific uses before receiving approval, healthcare providers may discover through clinical experience or research that it can be effective for treating other conditions. There may be benefits such as weight reduction for individuals within your range. If you agree to this off-label use, it\'s crucial to follow the prescribed regimen and report any concerns. Please discuss any questions with us.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'wlus_consentBmi_non_consent'
        },
        {
          key: 'wlus_consentBmi_consent',
          class: 'option-consent',
          value:
            'I acknowledge that I have read and understood the above information'
        }
      ]
    }
  },
  {
    field: 'wlus_MedicalConditions',
    label: 'Please check all current or past medical conditions:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'wlus_MedicalConditions_gastroparesis',
          value: 'Gastroparesis (Paralysis of your intestines)'
        },
        {
          key: 'wlus_MedicalConditions_triglyceridesOver600AtAnyPoint',
          value: 'Triglycerides over 600 at any point'
        },
        {
          key: 'wlus_MedicalConditions_pancreaticCancer',
          value: 'Pancreatic cancer'
        },
        {
          key: 'wlus_MedicalConditions_pancreatitis',
          value: 'Pancreatitis'
        },
        {
          key: 'wlus_MedicalConditions_type1Diabetes',
          value: 'Type 1 Diabetes'
        },
        {
          key: 'wlus_MedicalConditions_hypoglycemia',
          value: 'Hypoglycemia'
        },
        {
          key: 'wlus_MedicalConditions_insulinDependentDiabetes',
          value: 'Insulin-dependent diabetes'
        },
        {
          key: 'wlus_MedicalConditions_thyroidCancer',
          value: 'Thyroid cancer'
        },
        {
          key: 'wlus_MedicalConditions_familyHistoryOfThyroidCancer',
          value: 'Family history of thyroid cancer'
        },
        {
          key: 'wlus_MedicalConditions_familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome',
          value:
            'Personal or family history of Multiple Endocrine Neoplasia (MEN-2) syndrome'
        },
        {
          key: 'wlus_MedicalConditions_anorexiaOrBulimia',
          value: 'Anorexia or bulimia'
        },
        {
          key: 'wlus_MedicalConditions_currentSymptomaticGallstones',
          value: 'Current symptomatic gallstones'
        },
        {
          key: 'wlus_MedicalConditions_gallbladderRemoved',
          value: 'Gallbladder disease or past removal of your gallbladder'
        },
        {
          key: 'wlus_MedicalConditions_hypertensionHighBloodPressure',
          value: 'Hypertension (high blood pressure)'
        },
        {
          key: 'wlus_MedicalConditions_dyslipidemiaHighCholesterolOrTriglycerides',
          value: 'Dyslipidemia (high cholesterol or triglycerides)'
        },
        {
          key: 'wlus_MedicalConditions_sleepApnea',
          value: 'Sleep apnea'
        },
        {
          key: 'wlus_MedicalConditions_osteoporosis',
          value: 'Osteoporosis'
        },
        {
          key: 'wlus_MedicalConditions_mobilityIssuesWhichAreImpactedByBodyWeight',
          value: 'Mobility issues which are impacted by body weight'
        },
        {
          key: 'wlus_MedicalConditions_gastroesophagealRefluxDiseaseGERDRelatedToBodyWeight',
          value: 'Gastroesophageal reflux disease (GERD) related to body weight'
        },
        {
          key: 'wlus_MedicalConditions_polycysticOvarySyndromeWithInsulinResistance',
          value: 'Polycystic Ovary Syndrome with insulin resistance'
        },
        {
          key: 'wlus_MedicalConditions_liverDiseaseOrConditionsThatAffectTheLiver',
          value: 'Liver disease or conditions that affect the liver'
        },
        {
          key: 'wlus_MedicalConditions_heartDiseaseOrConditionsThatAffectTheHeart',
          value: 'Heart disease or conditions that affect the heart'
        },
        {
          key: 'wlus_MedicalConditions_metabolicSyndrome',
          value: 'Metabolic Syndrome'
        },
        {
          key: 'wlus_MedicalConditions_chronicKidneyDiseaseStage3OrGreater',
          value: 'Chronic Kidney Disease Stage 3 or greater'
        },
        {
          key: 'wlus_MedicalConditions_syndromeOfInappropriateAntidiureticHormone',
          value: 'Syndrome of Inappropriate Antidiuretic hormone'
        },
        {
          key: 'wlus_MedicalConditions_hypothyroidism,Hyperthyroidism,OrThyroidIssues',
          value: 'Hypothyroidism, Hyperthyroidism, or Thyroid Issues'
        },
        {
          key: 'wlus_MedicalConditions_prediabetes',
          value: 'Prediabetes'
        },
        {
          key: 'wlus_MedicalConditions_type2Diabetes',
          value: 'Type 2 Diabetes'
        },
        {
          key: 'wlus_MedicalConditions_noneOfTheAbove',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'wlus_consentGallbladder',
    label: 'Consent (gallbladder):',
    type: 'select',
    educationalSlide: `Read the following for more information about this product and its potential side effects. 
    Gallbladder disease information: You noted that you have gallbladder disease or previous removal of our gallbladder. This medication may still be a good option.  However, this medication can affect how the body handles fats and bile. If you have had your gallbladder removed, the body's ability to store and release bile is altered. Bile is crucial for digestion and fat absorption. This medication may increase the likelihood of gastrointestinal side effects in these individuals because it can alter fat metabolism and bile flow. This can lead to symptoms such as diarrhea and stomach pain. Additionally, medications that affect digestion and appetite, like this medication, might alter the absorption and metabolism of other nutrients (like fat soluble vitamins such as vitamin A, D, E, and K) and medications. This is particularly important for those without a gallbladder, as their digestive system already operates differently from those with a functioning gallbladder. If you wish to move forward, it is important to eat smaller and more frequent meals. In addition, to ensure that you're receiving enough vitamins, you should avoid processed foods while eating plenty of fruits and vegetables, as well as considering the use of a multi-vitamin unless told by your provider to avoid these for other reasons. If you have asymptomatic gallstones, please note that these medications and weight loss itself may result in gallstone formation which could result in the obstruction of the normal flow of bile which can result in infection, pancreatitis, and/or emergent need for gallbladder removal.  It is important to receive prompt medical evaluation if symptoms appear as delayed action may result in serious harm or death if untreated.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'wlus_consentGallbladder_non_consent'
        },
        {
          value:
            'I acknowledge that I have read and understood the above information and wish to continue.',
          class: 'option-consent',
          key: 'wlus_consentGallbladder_consent'
        }
      ]
    }
  },
  {
    label:
      'Please tell us more about your medical condition(s) that you selected',
    field: 'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
    }
  },
  {
    label: 'Please identify all your current medical conditions',
    field: 'wlus_identifyAllYourCurrentMedicalConditions',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_identifyAllYourCurrentMedicalConditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    extras: { sendToBeluga: false },
    field: 'wlus_listAllYourCurrentMedicationsIncludingDosages',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_listAllYourCurrentMedicationsIncludingDosages'
    }
  },
  {
    label: 'Please list all of your known allergies',
    extras: { sendToBeluga: false },
    field: 'wlus_listAllOfYourKnownAllergies',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_listAllOfYourKnownAllergies'
    }
  },
  {
    label: 'Have you had a gastric bypass in the past 6 months?',
    field: 'wlus_hadAGastricBypassInThePast6Months',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_hadAGastricBypassInThePast6Months_yes',
          value: 'Yes'
        },
        {
          key: 'wlus_hadAGastricBypassInThePast6Months_no',
          value: 'No'
        }
      ]
    }
  },
  {
    field: 'wlus_allergicToAnyOfTheFollowing',
    label:
      'Are you allergic to any GLP-1 medications such as Ozempic/Wegovy (Semaglutide), Mounjaro/Zepbound (Tirzepatide), Saxenda (Liraglutide), or Trulicity (Dulaglutide)?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'wlus_allergicToAnyOfTheFollowing_ozempic',
          value: 'Ozempic (Semaglutide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_mounjaro',
          value: 'Mounjaro (Tirzepatide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_wegovy',
          value: 'Wegovy (Semaglutide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_zepbound',
          value: 'Zepbound (Tirzepatide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_saxenda',
          value: 'Saxenda (Liraglutide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_trulicity',
          value: 'Trulicity (dulaglutide)'
        },
        {
          key: 'wlus_allergicToAnyOfTheFollowing_noneOfTheAbove',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Do you take any of the following medications?',

    field: 'wlus_doYouTakeAnyOfTheFollowingMedications',
    type: 'select',
    educationalSlide: `
- Insulin
- Glimepiride (Amaryl)
- Meglitinides such as repaglinide or nateglinide
- Glipizide (Glucotrol and Glucotrol XL)
- Glyburide (Micronase, Glynase, and Diabeta)
- Sitagliptin
- Saxagliptin
- Linagliptin
- Alogliptin
    `,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_doYouTakeAnyOfTheFollowingMedications_yes',
          value: 'Yes'
        },
        {
          key: 'wlus_doYouTakeAnyOfTheFollowingMedications_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: `Are you currently, or have you in the past two months, taken any of the following medications?`,

    field:
      'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
    type: 'select',

    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide',
          value: 'Semaglutide (Ozempic, Wegovy, Rybelsus)'
        },
        {
          key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide',
          value: 'Tirzepatide (Zepbound, Mounjaro)'
        },
        {
          key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_none',
          value: 'None of these'
        }
      ]
    }
  },
  {
    label: 'Have you experienced side effects from your current medication?',
    field: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes',
          value: 'Yes'
        },
        {
          key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: "Please describe the side effects that you've experienced",
    field: 'wlus_describeTheSideEffectsThatYouHaveExperienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_describeTheSideEffectsThatYouHaveExperienced'
    }
  },
  {
    label:
      'Which medication and dose most closely matches your most recent dose?',
    field: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    type: 'select',
    educationalSlide: `
      Keep in mind:
        Tirzepatide = Mounjaro, Zepbound
        Semaglutide = Ozempic, Wegovy
      
    `,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide0-25mg',
          value: 'Semaglutide 0.25mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide0-5mg',
          value: 'Semaglutide 0.5mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide1mg',
          value: 'Semaglutide 1mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide1-7mg',
          value: 'Semaglutide 1.7mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_semaglutide2-4mg',
          value: 'Semaglutide 2.4mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide2-5mg',
          value: 'Tirzepatide 2.5mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide5mg',
          value: 'Tirzepatide 5mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide7-5mg',
          value: 'Tirzepatide 7.5mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide10mg',
          value: 'Tirzepatide 10mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide12-5mg',
          value: 'Tirzepatide 12.5mg'
        },
        {
          key: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose_tirzepatide15mg',
          value: 'Tirzepatide 15mg'
        }
      ]
    }
  },
  {
    label: 'How would you like to continue your treatment?',
    field: 'wlus_howWouldYouLikeToContinueYourTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_howWouldYouLikeToContinueYourTreatment_stayAtTheSameDoseOrEquivalentDose',
          value: 'Stay at the same dose or equivalent dose'
        },
        {
          key: 'wlus_howWouldYouLikeToContinueYourTreatment_increaseTheDoseIfAHigherOneIsAvailableOrContinueWithMyCurrentDoseIfItSAlreadyAtTheMaximum',
          value:
            "Increase the dose if a higher one is available, or continue with my current dose if it's already at the maximum"
        },
        {
          key: 'wlus_howWouldYouLikeToContinueYourTreatment_decreaseDose',
          value: 'Decrease dose'
        }
      ]
    }
  },
  {
    label:
      "Do you have a photo of your current prescription? We need this image to verify your current dosage. If we're unable to confirm your prescription, we can only offer the starting dose.",
    field: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription_yes',
          value: 'Yes I have this information'
        },
        {
          key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription_no',
          value: "I don't have this information and I'm okay restarting"
        }
      ]
    }
  },
  {
    label:
      'Please upload a clear photo of your current prescription or bottle.\nMake sure the full label is visible, including your name, medication concentration, and usage instructions.',
    field:
      'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    answer: [
      {
        resourceId:
          'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication_file',
        buttonLabel: 'Upload Image'
      }
    ]
  },
  {
    label: 'Identity Verification',
    educationalSlide:
      'Upload a photo of a valid government-issued photo ID such as a driver’s license or passport which has your picture, name and date of birth clearly visible.  If applicable, upload a photo of the front and the back especially when using a military ID as your date of birth is on the back of the card.  Make sure the photo is clear and legible.',
    field: 'wlus_identityVerification',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'wlus_identityVerification_file',
        buttonLabel: 'Upload Image'
      }
    ]
  },
  {
    label: 'Full Body Image',
    educationalSlide:
      'To ensure the highest quality of care during your telemedicine consultation, we kindly request your assistance in providing a full-body clothed photo of yourself (please remain clothed but avoid wearing baggy apparel).  The image should include your face to help facilitate verification of your identity. Please be assured that these images will remain private and will not be shared. The physician will use the picture solely for assessment purposes to better understand your health condition. Thank you for your cooperation and understanding in helping to provide comprehensive care remotely. (Tip: using a full length mirror can help you capture this image)',
    field: 'wlus_fullBodyImage',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'wlus_fullBodyImage_file',
        buttonLabel: 'Upload Image'
      }
    ]
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
    }
  },
  {
    field: 'wlus_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.
    Consent: I verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'wlus_consentTruthfulness_non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'wlus_consentTruthfulness_consent'
        }
      ]
    }
  },

  {
    label: `Consent (Individualized Medication Treatment):`,
    educationalSlide: `We are committed to providing individualized care tailored to your unique health needs. As part of our treatment options, we are pleased to consider both FDA-approved, brand name medications and compounded alternatives. Our current evaluation considers:

    \tFDA-Approved Brand Name Medications:
    \t\tZepbound
    \t\tMounjaro
    \t\tOzempic
    \t\tWegovy


    \tCompounded Medications:
    \t\tFor patients who may benefit from a more specialized approach, we offer compounded formulations of semaglutide and tirzepatide. These compounded medications can be customized with alternative dosing schedules, alternative dosing frequencies, different routes of administration, and/or additives intended to help reduce side effects commonly seen with the brand name products. 
        
    Explanation of Compounded Medications:
        
    \tCompounded medications are custom-prepared by licensed pharmacists to better meet an individual patient’s specific needs. Unlike FDA-approved brand name products, compounded medications are not subject to the same rigorous testing and extensive clinical trials. This means that while they offer the advantage of customization, there may be differences in the consistency, efficacy, and safety profiles compared to those of the branded products.
            
    Consent and Acknowledgment:
        
    \tBy proceeding with this treatment plan, you acknowledge that:
    \t\tYou have been informed of the available treatment options, including both FDA-approved brand name medications and compounded alternatives.
        
    \t\tYou understand that compounded medications are tailored to meet individual needs but are not subjected to the same level of testing as brand name products.
        
    \t\tYour treatment plan will be determined based on your candidacy and specific health requirements, ensuring the most appropriate therapy for you.
        
        Please review this information carefully. If you have any questions or need further clarification regarding your treatment options, do not hesitate to ask our healthcare team. Your health and well-being are our highest priorities, and we are here to support you in making the best-informed decision about your care.`,
    field: 'wlus_individualizedConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'nonConsent',
          class: 'option-decline',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          class: 'option-consent',
          key: 'consent',
          required: true,
          value:
            'I have read and understand the above information and I do consent and wish to move forward with this treatment plan'
        }
      ]
    }
  },

  {
    field: 'wlus_consentGLP1GIP',
    label: 'Consent (GLP-1 and GIP/GLP-1):',
    type: 'select',
    educationalSlide: `
    Indication for Use
    You are requesting treatment with a GIP/GLP-1 (Ozempic, Wegovy, or compounded semaglutide) or GIP/GLP-1 receptor agonist (Mounjaro, Zepbound, or compounded tirzepatide) medication as part of your treatment plan for the management of weight or obesity. These medications work by mimicking the action of incretin hormones, which help regulate blood sugar levels, promote feeling full, and reduce food intake.

    Potential Benefits
        Weight loss or weight management
        Improved blood glucose control
        Reduced cardiovascular risk
        Potential improvement in overall metabolic health

    Potential Side Effects
    While these medications can be beneficial, they may also cause side effects. Although not common, these medications can result in emergency room visits, hospitalizations, or even death. Common and serious side effects include, but are not limited to:
    
    Common Side Effects:
    
        Nausea
        Vomiting
        Diarrhea
        Constipation
        Decreased appetite
        Indigestion
    

    Serious Side Effects:
    
        Pancreatitis (inflammation of the pancreas)
        Hypoglycemia (low blood sugar), especially when used with other diabetes medications
        Gallbladder disease (e.g., gallstones)
        Kidney problems
        Allergic reactions (e.g., rash, itching, swelling)
        Gastroparesis (paralysis of the bowels)
    

    Risks and Considerations
    
        Pancreatitis: There is a risk of developing pancreatitis. If you experience severe abdominal pain, nausea, or vomiting, you should contact your healthcare provider immediately.
        Thyroid Tumors: Animal studies have shown an increased risk of thyroid tumors with certain GLP-1 medications. Although this has not been confirmed in humans, please inform your healthcare provider if you have a history of thyroid cancer.
        Hypoglycemia: When taken with other diabetes medications, particularly insulin or sulfonylureas, there is a risk of low blood sugar. It is important that your provider knows if any of these medications are added to your regimen.
        Kidney Function: This medication may affect kidney function, particularly in patients with existing kidney disease. Regular monitoring of kidney function may be required.
    

    Monitoring and Follow-up
    You will require regular follow-up visits to monitor your response to the medication and to assess for any side effects. We may intermittently ask for full-body selfie images to ensure that your reported weight is consistent.

    I acknowledge the potential benefits, risks, and side effects of GLP-1 or GIP/GLP-1 receptor agonist medications. I understand the importance of regular monitoring and follow-up appointments. I consent to the use of GLP-1 or GIP/GLP-1 receptor agonist medications as part of my treatment plan for overweight or obesity.`,

    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_consentGLP1GIP_non_consent',
          class: 'option-decline',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          key: 'wlus_consentGLP1GIP_consent',
          class: 'option-consent',
          value:
            'I have read and understand the above information and I wish to continue'
        }
      ]
    }
  },

  // Medication sensitivities question
  {
    label:
      'People have different sensitivities to medications and commonly experience side effects to standard dosing regimens. ',
    educationalSlide: `Do you commonly experience side effects to medications or feel like you're sensitive to the impacts of most medications?`,
    field: 'wlus_medicationSensitivities',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Alternative Titration Regimen
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },

  // Medication effectiveness question
  {
    label: 'How are you doing on your medication?',
    field: 'wlus_howDoingOnMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to Rapid Titration Regimen
          key: 'rapidTitration',
          value:
            "I'm NOT losing weight (1-2 pounds/week) and I AM NOT having side effects"
        },
        {
          // Decided in next question
          key: 'sharedDecision',
          value:
            "I'm NOT losing weight (1-2 pounds/week) and I AM having side effects"
        },
        {
          // Route to Split Dosing
          key: 'splitDosing',
          value:
            "I'm losing weight (1-2 pounds/week) but I AM having side effects"
        },
        {
          // Route to Alternative Titration Regimen
          key: 'alternativeTitration',
          value:
            "I'm losing weight (1-2 pounds/week) and I AM NOT having side effects"
        }
      ]
    }
  },
  // Medication effectiveness question
  {
    label: 'How are you doing on your medication?',
    field: 'wlus_MedicationResults',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to Rapid Titration Regimen
          key: 'notLosing_noSideEffects',
          value:
            'I’m not feeling the effects of this medication and NOT losing weight (1-2 pounds/week) and I AM NOT having side effects'
        },
        {
          // Decided in next question
          key: 'notLosing_andSideEffects',
          value:
            'I’m not feeling the effects of this medication and NOT losing weight (1-2 pounds/week) and I AM having side effects'
        },
        {
          // Route to Split Dosing
          key: 'Losing_andSideEffects',
          value:
            'I’m feeling the effects of this medication and am losing weight (1-2 pounds/week) but I AM having side effects'
        },

        {
          // Route to Alternative Titration Regimen
          key: 'Losing_noSideEffects',
          value:
            'I’m feeling the effects of this medication and am losing weight (1-2 pounds/week) and I AM NOT having side effects'
        }
      ]
    }
  },
  // Shared decision making question
  {
    label:
      'Shared decision making is extremely important to ensure that this works into your lifestyle. Would you like to mitigate these side effects by:',
    field: 'wlus_sharedDecisionMaking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to split dosing regimen
          key: 'splitDosing',
          value:
            'I would like to inject a smaller dose twice a week instead of a larger dose once weekly to mitigate these symptoms'
        },
        {
          // Route to standard titration regimen
          key: 'standardTitration',
          value: 'No, I would like to stick with the standard dosing'
        }
      ]
    }
  },
  {
    label:
      'Are you able to safely give yourself injections or have someone help you?',
    field: 'wlus_fearOfNeedles',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value:
            'Yes, I’m not a good candidate for an injection and would need an oral formulation for a safer experience'
        },
        {
          key: 'no',
          value:
            'No, I’m capable of injecting myself and/or have good support with someone who can consistently help me'
        }
      ]
    }
  },
  {
    label:
      // 'Our providers have not yet reviewed your intake form but you may be a candidate for a brand name product which we’re happy to provide. Based on our experience as providers, we have developed an alternative dosing protocol which may provide a more comfortable experience for you. How would you like to proceed?',
      'Our providers have not yet reviewed your intake form, but you may be a candidate for a brand name product which we’re happy to provide. Based on our experience as providers we have developed an alternative dosing protocol using compounded GLP1 medications which may provide a more comfortable experience for you.  How would you like to proceed?',
    field: 'wlus_offerAlternative',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'brandNameDosing',
          value:
            'I would like the brand name product and brand name dosing protocol.'
        },
        {
          key: 'alternativeDosing',
          value:
            'I would like the compounded product with the alternative dosing protocol.'
        }
      ]
    }
  },
  {
    label:
      'Have you experienced any of the following side effects from your current medication? (Select all that apply)',
    field: 'wlus_sideEffects',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'fatigue',
          value:
            'Yes I have experienced fatigue and WOULD like to explore the option of including an additive which may help manage my fatigue symptoms'
        },
        {
          key: 'nausea',
          value:
            'Yes I have experienced nausea and WOULD like to explore the option of including an additive which may help reduce your nausea'
        },
        {
          key: 'muscleloss',
          value:
            'Yes I have experienced muscle loss and WOULD like to explore the option of including an additive which may help to support muscle health'
        },
        {
          key: 'noSideEffects',
          uncheckOthers: true,
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      '1a. Shared decision making is extremely important to ensure that this works into your lifestyle.  Would you like to increase to the next dose or would you like to transition to our Rapid Titration Protocol which allows you to increase the dose faster? ',
    field: 'wlus_sharedDecisionMakingFast',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to split dosing regimen
          key: 'alternativeTitration',
          value: 'I would like to increase to the next dose'
        },
        {
          // Route to standard titration regimen
          key: 'rapidTitration',
          value: 'I would like to transition to the Rapid Titration Protocol'
        }
      ]
    }
  },
  {
    label:
      '1b. Shared decision making is extremely important to ensure that this works into your lifestyle.  Would you like to mitigate these side effects by taking a smaller dose twice a week?',
    field: 'wlus_sharedDecisionMakingSlow',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          // Route to split dosing regimen
          key: 'splitDosing',
          value:
            'I would like to take a smaller dose twice a week instead of a larger dose once a week to mitigate these symptoms'
        },
        {
          // Route to standard titration regimen
          key: 'alternative',
          value:
            'No, I would like to stick with taking this medication at my current frequency'
        }
      ]
    }
  },
  {
    label: 'When were you first diagnosed with being overweight or obese?',
    field: 'wlus_diagnoseTimeline',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'prevYear',
          value: 'Within the last year'
        },
        {
          key: 'within5Years',
          value: '1-5 Years ago'
        },
        {
          key: 'moreThan5Years',
          value: 'More than 5 years ago'
        },
        {
          key: 'unsure',
          value: 'Unsure'
        }
      ]
    }
  },
  {
    label: 'How would you describe your current approach to weight management?',
    field: 'wlus_currentApproach',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'activelyManaging',
          value: 'Actively managing'
        },
        {
          key: 'effort',
          value: 'Some efforts'
        },
        {
          key: 'noEffort',
          value: 'No active efforts'
        }
      ]
    }
  },
  {
    label: 'How would you rate your current physical activity level?',
    field: 'wlus_physicalActivityLevel',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'sedentary',
          value: 'Sedentary (I don’t exercise)'
        },
        {
          key: 'light',
          value: 'Light'
        },
        {
          key: 'moderate',
          value: 'Moderate'
        },
        {
          key: 'vigorous',
          value: 'Vigorous'
        }
      ]
    }
  },
  {
    label: 'What dietary plan, if any, are you currently following?',
    field: 'wlus_dietaryPlan',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'none',
          value: 'None'
        },
        {
          key: 'minor',
          value: 'Minor modifications'
        },
        {
          key: 'significant',
          value: 'Significant dietary changes'
        }
      ]
    }
  },
  {
    field: 'previousWeightlossDrug',
    label: 'Most recent drug fulfilled at the time of completion',
    answer: {},
    extras: { sendToBeluga: false },
    type: 'evaluated'
  },
  {
    label: 'Do any of these apply to you?',
    field: 'wlus_medicalConditions2',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'gastroparesis',
          value: 'Gastroparesis (Paralysis of your intestines)'
        },
        {
          key: 'triglyceridesOver600',
          value: 'Triglycerides over 600 at any point'
        },
        {
          key: 'pancreaticCancerOrPancreatitis',
          value: 'Pancreatic cancer or pancreatitis'
        },
        {
          key: 'type1Diabetes',
          value: 'Type 1 Diabetes/Insulin-dependent diabetes'
        },
        {
          key: 'hypoglycemia',
          value: 'Hypoglycemia (low blood sugar)'
        },
        {
          key: 'medullaryThyroidCancer',
          value: 'Personal or family history of medullary thyroid cancer'
        },
        {
          key: 'men2',
          value:
            'Personal or family history of Multiple Endocrine Neoplasia (MEN-2) syndrome'
        },
        {
          key: 'anorexiaOrBulimia',
          value: 'Anorexia or bulimia'
        },
        {
          key: 'liverFailure',
          value: 'Liver failure/liver cirrhosis'
        },
        {
          key: 'ckd3b',
          value: 'Chronic Kidney Disease Stage 3b or greater'
        },
        {
          key: 'siadh',
          value: 'Syndrome of Inappropriate Antidiuretic hormone'
        },
        {
          key: 'symptomaticGallstones',
          value: 'Current symptomatic gallstones'
        },
        {
          key: 'gastricBypass6Months',
          value: 'Gastric bypass in the past 6 months'
        },
        {
          key: 'gallstonesNoSymptoms',
          value: 'Current gallstones without symptoms'
        },
        {
          key: 'gallbladderRemoved',
          value: 'Past removal of your gallbladder'
        },
        {
          key: 'thyroidIssues',
          value: 'Hypothyroidism, Hyperthyroidism, or Thyroid Issues'
        },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'wlus_consentGallstones',
    label: 'Gallstones Consent:',
    type: 'select',
    educationalSlide:
      'Use of GLP-1 medications, including semaglutide, tirzepatide, and similar products, has been associated with an increased risk of gallbladder or biliary issues, including the development or worsening of gallstones. If you have existing but asymptomatic gallstones, treatment may increase the chance that these stones become symptomatic, potentially leading to pain, inflammation, or the need for medical or surgical treatment. Notify your provider if you develop new upper abdominal pain, nausea, or vomiting during treatment. Knowing this risk, do you wish to continue?',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'non_consent',
          class: 'option-decline',
          value: 'I do NOT wish to continue'
        },
        {
          key: 'consent',
          class: 'option-consent',
          value:
            'I have read and understand the information above and wish to proceed'
        }
      ]
    }
  },
  {
    label:
      'Are you allergic to any GLP-1 medications such as Ozempic/Wegovy (Semaglutide), Mounjaro/Zepbound (Tirzepatide), Saxenda (Liraglutide), or Trulicity (Dulaglutide)?',
    field: 'wlus_allergicToGlp1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'wlusBranded_allergicToGlp1_yes', value: 'Yes' },
        { key: 'wlusBranded_allergicToGlp1_no', value: 'No' }
      ]
    }
  },
  {
    field: 'wlus_consentCholecystectomy',
    label: 'Cholecystectomy Consent:',
    type: 'select',
    educationalSlide:
      'You reported a history of gallbladder removal. This medication may still be appropriate but can alter fat and bile digestion, increasing the risk of side effects such as abdominal pain or diarrhea. It may also affect absorption of fat-soluble vitamins (A, D, E, and K); smaller meals, avoiding processed foods, and a daily multivitamin may help. Seek immediate care for severe abdominal pain, fever, or vomiting.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'non_consent',
          class: 'option-decline',
          value: 'I do NOT wish to continue'
        },
        {
          key: 'consent',
          class: 'option-consent',
          value:
            'I have read and understand the information above and wish to proceed'
        }
      ]
    }
  },
  {
    field: 'wlus_consentCholecystectomy',
    label: 'Cholecystectomy Consent:',
    type: 'select',
    educationalSlide:
      'You reported a history of gallbladder removal. This medication may still be appropriate but can alter fat and bile digestion, increasing the risk of side effects such as abdominal pain or diarrhea. It may also affect absorption of fat-soluble vitamins (A, D, E, and K); smaller meals, avoiding processed foods, and a daily multivitamin may help. Seek immediate care for severe abdominal pain, fever, or vomiting.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I do NOT wish to continue',
          class: 'option-decline',
          key: 'wlus_consentCholecystectomy_non_consent'
        },
        {
          value:
            'I have read and understand the information above and wish to proceed',
          class: 'option-consent',
          key: 'wlus_consentCholecystectomy_consent'
        }
      ]
    }
  },
  {
    label:
      'Are you able to safely give yourself injections or have someone help you?',
    field: 'wlus_ableToInjectOrHaveHelp',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlusBranded_ableToInjectOrHaveHelp_needOral',
          value:
            "No, I'd need an oral option instead (Direct to oral formulation or disqualified if not offered)"
        },
        {
          key: 'wlusBranded_ableToInjectOrHaveHelp_yes',
          value: 'Yes, I can inject myself or have reliable help'
        }
      ]
    }
  },
  {
    label: 'Have you taken any weight loss medications in the past 4 weeks?',
    field: 'wlus_weightLossMedicationsPast4Weeks',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_weightLossMedicationsPast4Weeks_semaglutide',
          value: 'Semaglutide (Ozempic, Wegovy, Rybelsus)'
        },
        {
          key: 'wlus_weightLossMedicationsPast4Weeks_tirzepatide',
          value: 'Tirzepatide (Zepbound, Mounjaro)'
        },
        {
          key: 'wlus_weightLossMedicationsPast4Weeks_none',
          value: 'None of these'
        }
      ]
    }
  },
  {
    label: 'When did you last take your prescribed weight loss medication?',
    field: 'wlus_whenLastTookMedication',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_whenLastTookMedication_pastWeek',
          value: 'Within the past week'
        },
        {
          key: 'wlus_whenLastTookMedication_past2To4Weeks',
          value: 'Within the past 2-4 weeks'
        }
      ]
    }
  },
  {
    label:
      'What was the approximate date you last injected your GLP-1 medication?',
    field: 'wlus_approximateDateLastInjected',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'wlus_approximateDateLastInjected'
    }
  },
  {
    field: 'wlus_consentDoseDecrease',
    label: 'Dose Decrease',
    type: 'select',
    educationalSlide:
      'Because these medications build up gradually in your system, restarting at a high dose after a break can increase the risk of side effects. For safety, we recommend continuing at a lower dose (usually about 50% of your previous dose) and gradually increasing if appropriate. How would you like to proceed?',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_consentDoseDecrease_agree',
          value: 'I understand and agree to continue at a lower dose'
        },
        {
          key: 'wlus_consentDoseDecrease_discuss',
          value: 'I would like to discuss this further with the provider'
        }
      ]
    }
  },
  {
    label: 'When did you last inject your GLP-1 medication?',
    field: 'wlus_dateLastInjected',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wlus_dateLastInjected_pastWeek',
          value: 'Within the past week'
        },
        {
          key: 'wlus_dateLastInjected_past2To4Weeks',
          value: 'Within the past 2-4 weeks'
        }
      ]
    }
  }
] as const;

export default questionsModels;
